import { render, staticRenderFns } from "./ClassroomActions.vue?vue&type=template&id=0fa4dffc&scoped=true"
import script from "./ClassroomActions.vue?vue&type=script&lang=js"
export * from "./ClassroomActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4dffc",
  null
  
)

export default component.exports